export const strings = {
    prefixAgo: null,
    prefixFromNow: null,
    suffixAgo: 'ކުރިން',
    suffixFromNow: 'ފަހުން',
    seconds: 'ސިކުންތުކޮޅެއް',
    minute: 'މިނިޓެއްވަރު',
    minutes: '%d މިނިޓު',
    hour: 'ގަޑިއެއްވަރު',
    hours: 'ގާތްގަނޑަކަށް %d ގަޑިއިރު',
    day: 'އެއް ދުވަސް',
    days: 'މީގެ %d ދުވަސް',
    month: 'މަހެއްވަރު',
    months: 'މީގެ %d މަސް',
    year: 'އަހަރެއްވަރު',
    years: 'މީގެ %d އަހަރު',
    wordSeparator: ' ',
};
